/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RateLimit } from './RateLimit';
import {
    RateLimitFromJSON,
    RateLimitFromJSONTyped,
    RateLimitToJSON,
    RateLimitToJSONTyped,
} from './RateLimit';

/**
 * 
 * @export
 * @interface ScoringEventConfig
 */
export interface ScoringEventConfig {
    /**
     * Event type from event pipeline (e.g., KILL, DEATH, MATCH_END_VICTORY)
     * @type {string}
     * @memberof ScoringEventConfig
     */
    eventType?: string;
    /**
     * Human-readable event type name, resolved from EventType by detail endpoints at read time. Not persisted.
     * @type {string}
     * @memberof ScoringEventConfig
     */
    eventTypeName?: string;
    /**
     * Custom description shown to users (overrides the auto-generated default)
     * @type {string}
     * @memberof ScoringEventConfig
     */
    description?: string;
    /**
     * Points/value this event contributes to score
     * @type {number}
     * @memberof ScoringEventConfig
     */
    value?: number;
    /**
     * 
     * @type {RateLimit}
     * @memberof ScoringEventConfig
     */
    rateLimit?: RateLimit;
    /**
     * Optional JSONata condition for when this event counts
     * @type {string}
     * @memberof ScoringEventConfig
     */
    condition?: string;
    /**
     * JSON Logic expression (https://jsonlogic.com) — opaque object whose root
     * key is an operator (e.g. "==", "and", "var") and value is its arguments.
     * Inlined here rather than $ref'd from JsonLogicRule because the openapi-generator
     * (typescript-fetch v6.2.1) treats `additionalProperties: true` schemas as
     * free-form interfaces with no FromJSON/ToJSON functions, but still emits
     * import statements for them in callers — producing a "JsonLogicRuleFromJSON
     * is not exported" build error. Inlining sidesteps the import chain.
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ScoringEventConfig
     */
    jsonValidator?: { [key: string]: any; };
}

/**
 * Check if a given object implements the ScoringEventConfig interface.
 */
export function instanceOfScoringEventConfig(value: object): value is ScoringEventConfig {
    return true;
}

export function ScoringEventConfigFromJSON(json: any): ScoringEventConfig {
    return ScoringEventConfigFromJSONTyped(json, false);
}

export function ScoringEventConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScoringEventConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'eventType': json['eventType'] == null ? undefined : json['eventType'],
        'eventTypeName': json['eventTypeName'] == null ? undefined : json['eventTypeName'],
        'description': json['description'] == null ? undefined : json['description'],
        'value': json['value'] == null ? undefined : json['value'],
        'rateLimit': json['rateLimit'] == null ? undefined : RateLimitFromJSON(json['rateLimit']),
        'condition': json['condition'] == null ? undefined : json['condition'],
        'jsonValidator': json['jsonValidator'] == null ? undefined : json['jsonValidator'],
    };
}

export function ScoringEventConfigToJSON(json: any): ScoringEventConfig {
    return ScoringEventConfigToJSONTyped(json, false);
}

export function ScoringEventConfigToJSONTyped(value?: ScoringEventConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'eventType': value['eventType'],
        'eventTypeName': value['eventTypeName'],
        'description': value['description'],
        'value': value['value'],
        'rateLimit': RateLimitToJSON(value['rateLimit']),
        'condition': value['condition'],
        'jsonValidator': value['jsonValidator'],
    };
}

